<template>
    <div class="h-screen main-panel" style="width: 100% !important;">
        <md-toolbar
            md-elevation="0"
            class="md-fixed-top md-toolbar-fixed md-toolbar-not-found"
        >
            <div class="md-toolbar-row">
                <div class="md-toolbar-section-start">
                    <h3 class="md-title">Gaia</h3>
                </div>
            </div>
        </md-toolbar>
        <div class="h-full w-full">
            <div class="container mx-auto h-full">
                <div class="flex items-center w-full justify-center">
                    <md-card>
                        <md-card-content>
                            <div class="text-center">
                                <h2 class="">Page web inaccessible</h2>
                                <p class="text-base">Vous essayer d'accéder à une page qui est en cours de développement.</p>
                                <div class="flex items-center justify-center mt-8">
                                    <md-button @click="goBack" class="md-warning" style="margin-right: 1rem !important;">Retourer à la page précédente</md-button>
                                    <md-button @click="goToRoute('Dashboard')" class="md-success">Retourer à la page d'accueil</md-button>
                                </div>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "NotFound",
    methods: {
        goToRoute(route) {
            this.$router.push({ name: route })
        },
        goBack() {
            this.$router.back()
        }
    },
    mounted() {
        document.title = 'Gaia - Page inaccessible'
    }
}
</script>

<style scoped lang="scss">
.md-toolbar-not-found {
    width: 100% !important;

    background-color: #3b3b3b !important;
    background-repeat: repeat !important;
    background-attachment: scroll !important;
    background-image: none !important;
    background-origin: padding-box !important;
    background-clip: border-box !important;

    -webkit-box-shadow: 0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(59, 59, 59, 0.46) !important;
    box-shadow: 0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(59, 59, 59, 0.46) !important;
    background-size: cover !important;
    background-position: 50% !important;

    -webkit-transition-property: top, bottom, width, background-image;
    transition-property: top, bottom, width, background-image;
    -webkit-transition-duration: 0.2s, 0.2s, 0.35s, 0.3s;
    transition-duration: 0.2s, 0.2s, 0.35s, 0.3s;
    -webkit-transition-timing-function: linear, linear, ease, linear;
    transition-timing-function: linear, linear, ease, linear;
}
</style>
